import React, { useEffect } from 'react';

declare global {
  interface Window {
    kofiWidgetOverlay?: {
      draw: (username: string, options: Record<string, string>) => void;
    };
  }
}

const KoFiButton = () => {
  useEffect(() => {
    const initializeKoFiWidget = () => {
      if (window.kofiWidgetOverlay) {
        console.log('KoFiButton.useEffect kofiWidgetOverlay FOUND...');
        console.log('Initializing Ko-fi widget');
        window.kofiWidgetOverlay.draw('shadowdarktools', {
          type: 'floating-chat',
          'floating-chat.donateButton.text': 'Donate',
          'floating-chat.donateButton.background-color': '#323842',
          'floating-chat.donateButton.text-color': '#fff',
        });
      } else {
        console.log('kofiWidgetOverlay not ready, retrying...');
        setTimeout(initializeKoFiWidget, 100); // Retry until kofiWidgetOverlay is ready
      }
    };

    // Attempt to initialize the widget
    initializeKoFiWidget();

    return () => {
      console.log('Cleaning up Ko-fi widget');
    };
  }, []);

  return <div></div>;
};

export default KoFiButton;